var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 8.75v-3h-3v-1.5h3v-3h1.5v3h3v1.5h-3v3zM7.154 21.558q-.73 0-1.24-.511-.51-.51-.51-1.24 0-.727.51-1.239.51-.51 1.24-.51.729 0 1.24.51.51.51.51 1.24 0 .729-.51 1.239-.511.51-1.24.51m9.692 0q-.729 0-1.24-.511-.51-.51-.51-1.24 0-.727.51-1.239.511-.51 1.24-.51.73 0 1.24.51t.51 1.24q0 .729-.51 1.239t-1.24.51M1.5 3.75v-1.5h2.862l4.172 8.808h6.818a.3.3 0 0 0 .154-.043.4.4 0 0 0 .115-.12L19.32 4.25h1.708l-4.093 7.392a1.8 1.8 0 0 1-.65.674 1.7 1.7 0 0 1-.888.242H8.1l-1.158 2.115q-.077.115-.005.25t.217.135h11.442v1.5H7.154q-1 0-1.51-.855-.511-.855-.029-1.73l1.427-2.565L3.404 3.75z"
  })));
};
export default SvgShoppingCart;